import { render, staticRenderFns } from "./vsInput.vue?vue&type=template&id=c366965c&lang=html"
import script from "./vsInput.vue?vue&type=script&lang=js"
export * from "./vsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports